<template>
  <div>
    <small>
      {{ 'Already have an account?' | translate }}
      <a href="#" @click.prevent="openModal">
        {{ 'Sign in' | translate }}
      </a>
    </small>
    <div ref="modal" class="modal fade" tabindex="-1" aria-labelledby="loginModal" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content login-modal-content">

          <!-- Close button -->
          <button type="button" class="btn-close login-modal-close" data-bs-dismiss="modal" aria-label="Close"></button>

          <!-- Top icon area -->
          <div class="login-modal-icon">
            <i class="fas fa-user"></i>
          </div>

          <div class="modal-body px-4 pt-2 pb-4">
            <h5 class="text-center fw-bold mb-1">{{ 'Sign in' | translate }}</h5>
            <p class="text-center text-muted small mb-4">{{ 'Welcome back! Please sign in to continue.' | translate }}</p>

            <div class="mb-3">
              <label for="inputEmail" class="form-label small fw-semibold">{{ 'Email' | translate }}</label>
              <input
                type="email"
                id="inputEmail"
                class="form-control login-input"
                :class="{ 'is-invalid': 'email' in errors }"
                :placeholder="'your@email.com' | translate"
                required=""
                autofocus=""
                v-model="email"
              />
              <InputErrors name="email" :errors="errors"></InputErrors>
            </div>

            <div class="mb-2">
              <label for="inputPassword" class="form-label small fw-semibold">{{ 'Password' | translate }}</label>
              <input
                type="password"
                id="inputPassword"
                class="form-control login-input"
                :class="{ 'is-invalid': 'password' in errors }"
                required=""
                v-model="password"
              />
              <InputErrors name="password" :errors="errors"></InputErrors>
            </div>

            <div class="text-end mb-4">
              <a href="/password/reset" class="text-muted small login-forgot-link">
                {{ 'Forgot Your Password?' | translate }}
              </a>
            </div>

            <button @click.prevent="login" type="button" class="btn btn-dark w-100 login-btn">
              {{ 'Sign in' | translate }}
            </button>

            <div class="text-center mt-3">
              <button type="button" class="btn btn-link btn-sm text-muted login-cancel-link" @click.prevent="hideModal">
                {{ 'Cancel' | translate }}
              </button>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '../../helpers/api'
import InputErrors from './InputErrors'
import _ from 'lodash'

export default {
  components: {
    InputErrors,
  },
  data() {
    return {
      email: null,
      password: null,
      errors: [],
    }
  },
  mounted() {
    this.modal = new bootstrap.Modal(this.$refs.modal, {})
  },
  computed: {
    course_id() {
      return _.get(this.$store.state, 'course.id', null)
    },
  },
  methods: {
    openModal() {
      this.modal.show()
    },
    hideModal() {
      this.errors = []
      this.email = null
      this.password = null
      this.modal.hide()
    },
    setView() {
      this.$store.commit('setView', 'register')
    },
    async login() {
      try {
        let loginData = {
          email: this.email,
          password: this.password,
        }

        if (this.course_id) {
          loginData.course_id = this.course_id
        }

        const response = await api.login(loginData)
        this.$store.dispatch('checkPromoCodeOnLogin')
        this.$store.commit('updateUser', response.data.student)
        this.$store.commit('updateHasAccess', response.data.has_access)
        this.hideModal()
      } catch (error) {
        let status = _.get(error, 'response.status')

        if (status === 422) {
          this.errors = _.get(error, 'response.data.errors', [])
        } else {
          console.error(error)
        }
      }
    },
  },
}
</script>

<style scoped>
.login-modal-content {
  border: none;
  border-radius: 1rem;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
  overflow: hidden;
  padding-top: 2.5rem;
}

.login-modal-close {
  position: absolute;
  top: 1rem;
  right: 1rem;
  z-index: 10;
  opacity: 0.4;
}

.login-modal-close:hover {
  opacity: 0.8;
}

.login-modal-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 3.5rem;
  height: 3.5rem;
  background: #212529;
  border-radius: 50%;
  margin: 0 auto 0.75rem;
  color: #fff;
  font-size: 1.25rem;
}

.login-input {
  border-radius: 0.5rem;
  padding: 0.625rem 0.875rem;
  border-color: #dee2e6;
  transition: border-color 0.2s, box-shadow 0.2s;
}

.login-input:focus {
  border-color: #212529;
  box-shadow: 0 0 0 3px rgba(33, 37, 41, 0.1);
}

.login-btn {
  border-radius: 0.5rem;
  padding: 0.625rem;
  font-weight: 600;
  letter-spacing: 0.01em;
}

.login-forgot-link {
  text-decoration: none;
  font-size: 0.8rem;
}

.login-forgot-link:hover {
  color: #212529 !important;
  text-decoration: underline;
}

.login-cancel-link {
  font-size: 0.8rem;
  text-decoration: none;
}

.login-cancel-link:hover {
  text-decoration: underline;
}
</style>
